import * as Yup from 'yup';

const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .label('Current password')
    .min('1')
    .required(),
  newPassword: Yup.string()
    .label('New password')
    .min('1')
    .required()
    .test({
      name: 'passwords-match',
      test: function testPasswordsMatch(value) {
        return this.parent.oldPassword !== value;
      },
      message: `The old and new password cannot be the same`,
    }),
  confirmNewPassword: Yup.string()
    .label('Confirm new password')
    .min('1')
    .required()
    .test({
      name: 'passwords-match',
      test: function testPasswordsMatch(value) {
        return this.parent.newPassword === value;
      },
      message: `Passwords don't match`,
    }),
});

export { changePasswordSchema };
